import React, { SFC, SVGProps, useEffect, useState } from 'react'
import styles from './styles.module.scss'
import XText from 'v2/components/XText'
import XLink from 'v2/components/XLink'
import { BUTTON_SIZE, BUTTON_STYLE_TYPE, XTEXT_MARGINS, XTEXT_SIZE } from 'v2/styles/constants'
import XColors from 'v2/styles/colors'
import XButton from 'v2/components/XButton'
import { desktopThreshold } from 'components/BaseComponents/constants'
import { ga4_cardClicked } from 'utils/ga4'

interface Props {
    headerText: string
    normalText: string
    linkText?: string
    id?: string
    linkPath?: string
    icon?: string
    customIcon?: SFC<SVGProps<SVGSVGElement>>
    onClick: () => void
    disabled?: boolean
    ga4_key?: string
}

const XRow = (props: Props) => {
    const { headerText, normalText, linkText, linkPath, icon, customIcon, disabled, id } = props
    const [isMobile, setIsMobile] = useState(false)
    const onResize = () => {
        setIsMobile(window.innerWidth < desktopThreshold)
    }

    useEffect(() => {
        onResize()
        window.removeEventListener('resize', onResize)
        window.addEventListener('resize', onResize)
    }, [])

    const onClick = () => {
        if (props.ga4_key) {
            ga4_cardClicked(props.ga4_key)
        }
        props.onClick?.()
    }

    return (
        <div
            id={id}
            className={styles.xRow__container}
            onClick={!disabled ? onClick : () => {}}
            data-disabled={!!disabled}
        >
            <XLink customIcon={customIcon} icon={icon} href={linkPath} />
            <div className={styles.xRow__textContainer}>
                <XText color={XColors.midGray} size={XTEXT_SIZE.LARGE}>
                    {headerText}
                </XText>
                <div className={styles.xRow__normalText}>
                    <XText color={XColors.darkGray} margins={XTEXT_MARGINS.NO_MARGINS}>
                        {normalText}
                    </XText>
                </div>
                {linkText && !disabled && <XLink href={linkPath}>{linkText}</XLink>}
            </div>
            <XButton
                styleType={BUTTON_STYLE_TYPE.ICON}
                size={isMobile ? BUTTON_SIZE.ICON_MOBILE : BUTTON_SIZE.ICON_LARGER}
                rightIcon={'arrow_forward'}
                onClick={!disabled ? onClick : () => {}}
            />
        </div>
    )
}

export default XRow
